module.exports = __webpack_public_path__ + "img/section2Icon1.20669b15.svg";